import type { PaymentStatus } from '@ecom/contracts';
import type { MessageKey } from '@/i18n/messages';
import type { PillTone } from '@/components/ui';

/**
 * How the money stands on an order, as a word and a colour.
 *
 * Cash on delivery reads in its own terms: "pending" there means the courier
 * has not collected it yet, and "paid" means it was collected at the door —
 * not the same news as a card that is waiting or went through (ADR-061).
 */
export function paymentLabelKey(status: PaymentStatus, cash: boolean): MessageKey {
  if (cash && (status === 'PENDING' || status === 'SUCCEEDED')) return `paymentState_${status}_COD`;
  return `paymentState_${status}`;
}

export function paymentTone(status: PaymentStatus): PillTone {
  switch (status) {
    case 'SUCCEEDED':
      return 'success';
    case 'PENDING':
    case 'PARTIALLY_REFUNDED':
      return 'warning';
    case 'FAILED':
    case 'REFUNDED':
      return 'danger';
    default:
      return 'neutral';
  }
}

/**
 * Money that came in by hand — cash at the door, a transfer recorded by staff —
 * goes back by hand, and says how (ADR-061, ADR-062).
 */
export function paidByHand(order: { paymentMethod: string; payment?: { provider: string } | null }): boolean {
  const provider = order.payment?.provider;
  return provider === 'cod' || provider === 'manual' || order.paymentMethod === 'COD' || order.paymentMethod === 'MANUAL';
}
